/*
 * Tiroir de recherche par dimension, en tête de /collections/pneus.
 *
 * Pourquoi il existe : un client qui arrive par l'entrée « Pneus » du menu tombait sur la liste
 * complète du catalogue, toutes dimensions confondues, avec pour seuls filtres la marque et le
 * prix. Aucun moyen de dire « la mienne est en 195/65 R15 ». La recherche par dimension
 * n'existait que dans le tiroir du widget, sur la page d'accueil.
 *
 * Trois partis pris :
 *
 *   1. Les listes viennent du CATALOGUE PUBLIÉ (assets/mauto-pneu-dimensions.js), jamais d'une
 *      échelle en dur. Le client ne peut donc pas choisir une largeur que le garage ne référence
 *      pas et se retrouver devant une page vide. Les trois listes se resserrent en cascade :
 *      choisir 195 en largeur ne laisse que les hauteurs réellement disponibles en 195.
 *
 *   2. Valider recharge la page avec les paramètres d'URL, au lieu de re-rendre les résultats en
 *      place. Tout le reste du parcours lit déjà ces paramètres — compatibilité des indices,
 *      repli de saison, récapitulatif, mémoire du lien « Continuer mes achats ». Les rejouer
 *      plutôt que les contourner évite d'avoir deux chemins qui peuvent diverger.
 *
 *   3. Tant qu'aucune dimension n'est choisie, on n'impose rien : les pneus restent affichés en
 *      dessous. Le tiroir invite, il ne barre pas la route.
 */
(function () {
  'use strict';

  var CHAMPS = ['largeur', 'hauteur', 'diametre'];
  var hote, index = null;
  var choix = { largeur: '', hauteur: '', diametre: '', saison: '' };

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function lireUrl() {
    var p = new URLSearchParams(window.location.search);
    CHAMPS.forEach(function (c) { choix[c] = p.get(c) || ''; });
    choix.saison = p.get('saison') || '';
  }

  function dimensionComplete() {
    return Boolean(choix.largeur && choix.hauteur && choix.diametre);
  }

  // Saisons réellement présentes dans le catalogue, pour ne pas proposer un filtre vide.
  function saisonsDuCatalogue() {
    var el = document.getElementById('pneus-catalogue-data');
    if (!el) return [];
    try {
      var data = JSON.parse(el.textContent || '[]');
      var vues = {}, out = [];
      data.forEach(function (p) { if (p.saison && !vues[p.saison]) { vues[p.saison] = 1; out.push(p.saison); } });
      return out.sort();
    } catch (e) { return []; }
  }

  function listeOptions(champ) {
    var mod = window.MautoPneuDimensions;
    if (!mod || !index) return [];
    // La sélection transmise ne contient que les champs situés AVANT celui-ci : une hauteur déjà
    // choisie ne doit pas restreindre les largeurs proposées, sinon le client ne peut plus
    // revenir en arrière sans tout effacer.
    var sel = {};
    for (var i = 0; i < CHAMPS.length; i++) {
      if (CHAMPS[i] === champ) break;
      if (choix[CHAMPS[i]]) sel[CHAMPS[i]] = choix[CHAMPS[i]];
    }
    return mod.options(index, champ, sel).dispo;
  }

  function selecteur(champ, libelle, prefixe, suffixe) {
    var valeurs = listeOptions(champ);
    var options = ['<option value="">' + esc(libelle) + '</option>'];
    valeurs.forEach(function (v) {
      options.push('<option value="' + esc(v) + '"' + (choix[champ] === String(v) ? ' selected' : '') + '>' +
        esc((prefixe || '') + v + (suffixe || '')) + '</option>');
    });
    return '<label class="pneus-recherche-champ">' +
      '<span>' + esc(libelle) + '</span>' +
      '<select data-dim="' + champ + '">' + options.join('') + '</select>' +
      '</label>';
  }

  // Le rendu remplace tout le contenu du tiroir : le select que le client vient d utiliser
  // disparait avec lui et le clavier repart en haut du document. On lui rend le focus, sauf au
  // tout premier rendu ou personne n a encore rien touche.
  function rendre(champFocus) {
    var saisons = saisonsDuCatalogue();
    var pret = dimensionComplete();

    var html =
      '<div class="pneus-recherche-entete">' +
        '<p class="pneus-recherche-titre">Quelle est la dimension de vos pneus&nbsp;?</p>' +
        '<p class="pneus-recherche-aide">Elle est inscrite sur le flanc du pneu, par exemple <strong>195/65 R15</strong>.</p>' +
      '</div>' +
      '<div class="pneus-recherche-ligne">' +
        selecteur('largeur', 'Largeur') +
        selecteur('hauteur', 'Hauteur') +
        selecteur('diametre', 'Diamètre', 'R') +
        (saisons.length > 1 ?
          '<label class="pneus-recherche-champ">' +
            '<span>Saison</span>' +
            '<select data-dim="saison">' +
              '<option value="">Toutes</option>' +
              saisons.map(function (s) {
                return '<option value="' + esc(s) + '"' + (choix.saison === s ? ' selected' : '') + '>' + esc(s) + '</option>';
              }).join('') +
            '</select>' +
          '</label>' : '') +
        '<button type="button" class="pneus-recherche-valider"' + (pret ? '' : ' disabled') + ' data-valider>' +
          'Voir les pneus' +
        '</button>' +
      '</div>' +
      (dimensionComplete() || aDesParametres() ?
        '<button type="button" class="pneus-recherche-effacer" data-effacer>Effacer la recherche</button>' : '');

    hote.innerHTML = html;
    hote.hidden = false;
    brancher();
    if (champFocus) {
      var repris = hote.querySelector('select[data-dim="' + champFocus + '"]');
      if (repris) repris.focus();
    }
  }

  function aDesParametres() {
    var p = new URLSearchParams(window.location.search);
    return CHAMPS.some(function (c) { return p.get(c); }) || Boolean(p.get('saison'));
  }

  function brancher() {
    var selects = hote.querySelectorAll('select[data-dim]');
    for (var i = 0; i < selects.length; i++) {
      selects[i].addEventListener('change', function (ev) {
        var champ = ev.currentTarget.getAttribute('data-dim');
        choix[champ] = ev.currentTarget.value;
        // Changer un champ invalide ceux qui en dépendent : une hauteur retenue pour une autre
        // largeur n'existe peut-être pas ici, et laisser une valeur impossible mènerait à une
        // page vide.
        var rang = CHAMPS.indexOf(champ);
        if (rang !== -1) {
          for (var j = rang + 1; j < CHAMPS.length; j++) choix[CHAMPS[j]] = '';
        }
        rendre(champ);
      });
    }

    var valider = hote.querySelector('[data-valider]');
    if (valider) valider.addEventListener('click', lancerRecherche);

    var effacer = hote.querySelector('[data-effacer]');
    if (effacer) {
      effacer.addEventListener('click', function () {
        window.location.href = window.location.pathname;
      });
    }
  }

  function lancerRecherche() {
    if (!dimensionComplete()) return;
    var p = new URLSearchParams();
    CHAMPS.forEach(function (c) { p.set(c, choix[c]); });
    if (choix.saison) p.set('saison', choix.saison);
    // La quantité déjà choisie est conservée : le client qui affine sa dimension ne doit pas
    // repasser de 4 pneus à 2 sans l'avoir demandé.
    var q = new URLSearchParams(window.location.search).get('quantite');
    if (q) p.set('quantite', q);
    window.location.href = window.location.pathname + '?' + p.toString();
  }

  function init() {
    hote = document.getElementById('pneus-recherche-dimension');
    if (!hote || !window.MautoPneuDimensions) return;
    lireUrl();
    // charger() ne rejette jamais : il signale l'échec par { erreur: true, fiches: [] }. Un
    // tiroir dont les listes seraient vides ne mènerait nulle part — on le laisse alors masqué,
    // les résultats restent affichés en dessous.
    window.MautoPneuDimensions.charger()
      .then(function (idx) {
        if (!idx || idx.erreur || !idx.fiches || !idx.fiches.length) { hote.hidden = true; return; }
        index = idx;
        rendre();
      })
      .catch(function () { hote.hidden = true; });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
